/*
 *  This file is used to initialize the replatforming Apple Pay Widget
 * */

async function skuChanged(event) {
    const sku = event.target.value;
    if (window.applePayWidget) {
        window.applePayWidget.update(sku);
    }
}

const productSize = document.querySelector('select[name="size"]');
productSize.addEventListener('productSizeChanged', skuChanged);
